import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/modules/auth/hooks/auth-context';

/**
 * Barreira das rotas do painel.
 *
 * Enquanto a primeira verificação de sessão não termina, mostra um aviso de
 * carregamento em vez de redirecionar. Redirecionar durante essa janela faria
 * a tela de login piscar a cada F5 para quem está autenticado.
 *
 * Isto é conveniência de navegação, não segurança: quem chamar a API direto
 * continua sendo barrado pelo servidor. Nenhuma decisão de autorização depende
 * deste componente.
 */
export function ProtectedRoute() {
  const { usuario, carregando } = useAuth();
  const localizacao = useLocation();

  if (carregando) {
    return (
      <div
        className="flex min-h-screen items-center justify-center px-6"
        role="status"
        aria-live="polite"
      >
        <p className="text-sm text-ink-soft">Verificando a sessão…</p>
      </div>
    );
  }

  if (!usuario) {
    // `state.de` guarda onde a pessoa queria chegar, para o login devolvê-la
    // ao destino em vez de despejá-la sempre na visão geral.
    return <Navigate to="/login" replace state={{ de: localizacao.pathname }} />;
  }

  return <Outlet />;
}
